import { AutogenModelFuelReimburseLookup, AutogenRowFuelReimburseLookup } from "./autogen/AutogenModelFuelReimburseLookup";

export class ModelFuelReimburseLookup extends AutogenModelFuelReimburseLookup<RowFuelReimburseLookup> {
	constructor() {
		super(RowFuelReimburseLookup);
	}
}

export class RowFuelReimburseLookup extends AutogenRowFuelReimburseLookup {
}